<template>
<div>
  <div class="title-h3 title-bar">중요 프로세스 개별 등록</div>
  <hr class="mr-b20" />
  <div class="mr-b30">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h4 dot-title">{{majorListTitle}}</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" :disabled="!noAddList" @click="majorProcApply"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" :disabled="!isDeleted" @click="deleteMajorProcList"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="majorShowSearchTool = !majorShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="majorProcData" row-class-name="c-dblclick" :column-default="columnDefault" :columns="majorProcColumns" :pagination="false" @row-dblclick="editMajorProcList"
      @selection-change="majorChangeSelection" :show-custom-header="true" :show-search-tool="majorShowSearchTool" style="width:100%;">
      <template slot-scope="scope" slot="autoCommand">
        <el-checkbox disabled v-model="scope.row.processStopAutostartFlag" true-label="1" false-label="0"></el-checkbox>
      </template>
    </el-table-wrapper>
  </div>
  <div>
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h4 dot-title">{{autoListTitle}}</div>
      <div>
        <el-button type="primary" :disabled="!isAutoListDeleted" @click="autoProcApply">등록하기</el-button>
        <w-header-search-button @click="autoShowSearchTool = !autoShowSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :data="autoProcData" :columns="autoProcColumns" :column-default="columnDefault" :pagination="false" :show-custom-header="true" @selection-change="autoChangeSelection" :show-search-tool="autoShowSearchTool" style="width:100%;">
      <template slot-scope="scope" slot="autoCommand">
        <el-checkbox disabled v-model="scope.row.processStopAutostartFlag" true-label="Y" false-label="N"></el-checkbox>
      </template>
      <template slot-scope="scope" slot="processIdInput">
        <el-input v-model="scope.row.processId" placeholder="입력해 주세요."></el-input>
      </template>
    </el-table-wrapper>
  </div>

  <w-indivisual-proc-popup ref="indivisualProcPopup" :serverId="serverId" @reload-data="loadData" :editRow="editRow" :popup-type="indivisualProcPopupType" :selectPhysicalNode="selectPhysicalNode"></w-indivisual-proc-popup>
</div>
</template>

<script>
import { isNil, cloneDeep, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WIndivisualProcPopup from '@/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/IndivisualProcPopup';

export default {
  name: 'WMajorProcIndivisualApply',
  components: {
    WSettingsDetail,
    WIndivisualProcPopup,
  },
  props: {
    selectPhysicalNode: Object,
    serverId: Number,
  },
  data() {
    return {
      columnDefault,
      params: {
        serverId: null,
      },
      isDeleted: false,
      noAddList: false,
      isAutoListDeleted: false,
      majorListTitle: '',
      autoListTitle: '',
      indivisualProcPopupType: null,
      changeMajorList: [],
      autoChangeList: [],
      editRow: {},
      majorShowSearchTool: false,
      autoShowSearchTool: false,
      majorProcData: null,
      autoProcData: null,
      majorProcColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'processId',
          label: '프로세스 ID',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processName',
          label: '프로세스명',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processStopAutostartFlag',
          label: '명령어 자동실행여부',
          scopedSlot: 'autoCommand',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStart',
          label: '동작 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStop',
          label: '정지 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processPort',
          label: '포트번호',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      autoProcColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'processId',
          label: '프로세스 ID',
          scopedSlot: 'processIdInput',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'oneType',
          label: '1차 분류',
          width: 200,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'twoType',
          label: '2차 분류',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processName',
          label: '프로세스명',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processStopAutostartFlag',
          label: '명령어 자동실행여부',
          scopedSlot: 'autoCommand',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStart',
          label: '동작 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processCommandStop',
          label: '정지 제어 명령',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'processPort',
          label: '포트번호',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  watch: {
    serverId: {
      handler() {
        if (!isNil(this.serverId)) {
          this.params.serverId = this.serverId;
          this.loadData();
        }
      },
      immediate: true,
    },
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.selectPhysicalNode)) {
          if (this.selectPhysicalNode.type === 'obj') {
            this.noAddList = true;
          } else {
            this.noAddList = false;
            this.majorProcData = null;
            this.autoProcData = null;
          }
          this.majorListTitle = `[${this.selectPhysicalNode.label}] 중요 프로세스 목록`;
          this.autoListTitle = `[${this.selectPhysicalNode.label}] 자동 등록 프로세스 목록`;
        }
      },
      immediate: true,
    },
    changeMajorList: {
      handler() {
        if (this.changeMajorList.length > 0) {
          this.isDeleted = true;
        } else {
          this.isDeleted = false;
        }
      },
      immediate: true,
    },
    autoChangeList: {
      handler() {
        if (this.autoChangeList.length > 0) {
          this.isAutoListDeleted = true;
        } else {
          this.isAutoListDeleted = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      if (this.selectPhysicalNode.type === 'obj') {
        // 중요프로세스 목록
        ServerSettingAPI.getMajorProcessListByServer(this.params).then((response) => {
          if (response.data.success) {
            this.majorProcData = clone(response.data.data);
          }
        });
        // 자동 등록 프로세스 목록
        ServerSettingAPI.getAutoProcessByServer(this.params).then((response) => {
          if (response.data.success) {
            this.autoProcData = cloneDeep(response.data.data);
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [majorChangeSelection 중요 프로세스 항목의 체크리스트를 관리한다.]
     * @author Ju
     * @param  {[type]} selectVal [description]
     * @return {[type]}           [description]
     */
    majorChangeSelection(selectVal) {
      this.changeMajorList = selectVal;
    },
    /**
     * [autoChangeSelection 자동 프로세스 항목의 체크리스트를 관리한다.]
     * @author yelim
     * @param  {[type]} selectVal [description]
     * @return {[type]}           [description]
     */
    autoChangeSelection(selectVal) {
      this.autoChangeList = selectVal;
    },
    /**
     * [majorProcApply 중요 프로세스 항목을 추가한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    majorProcApply() {
      this.editRow = {};
      this.indivisualProcPopupType = 'ADD';
      this.$refs.indivisualProcPopup.open();
    },
    /**
     * [editMajorProcList 중요 프로세스 항목을 수정한다.]
     * @author yelim
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    editMajorProcList(row) {
      this.editRow = cloneDeep(row);
      this.indivisualProcPopupType = 'EDIT';
      this.$refs.indivisualProcPopup.open();
    },
    /**
     * [deleteMajorProcList 중요 프로세스 항목을 삭제한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    deleteMajorProcList() {
      const target = '중요 프로세스';
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        if (!isNil(this.changeMajorList)) {
          ServerSettingAPI.deleteIndivisualMajorProcess(this.changeMajorList).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, target, true));
              this.loadData();
            }
          });
        }
      });
    },
    /**
     * [autoProcApply 개별 설정 > 자동 등록 프로세스를 등록한다.]
     * @author yelim
     * @return {[type]} [description]
     */
    autoProcApply() {
      const objId = this.selectPhysicalNode.obj.objId;
      if (!isNil(this.autoChangeList)) {
        const majorProcList = this.autoChangeList;
        // 프로세스 아이디가 중복되는 경우 message 창을 출력한다.
        ServerSettingAPI.insertAutoProcess({
          majorProcList,
          objId,
        }).then((response) => {
          if (response.data.success) {
            this.loadData();
            const target = '중요 프로세스';
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, true));
          } else if (response.data.message === 'IS_EXISTS') {
            this.$message({
              message: '중요 프로세스를 등록했습니다. (등록되지 않은 프로세스는 프로세스 ID를 변경 후 등록해주세요.)',
              type: 'success',
            });
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/component/MajorProcIndivisualApply.vue